module.exports = __webpack_public_path__ + "static/media/w (29).f18d1d7a.jpg";